import { render, staticRenderFns } from "./v80b2010.vue?vue&type=template&id=1e5f24e1&"
import script from "./v80b2010.vue?vue&type=script&lang=js&"
export * from "./v80b2010.vue?vue&type=script&lang=js&"
import style0 from "./v80b2010.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports